import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  stepContainer: {
    display: 'flex',
    position: 'relative',
    marginBottom: theme.spacing(2)
  },
  verticalLine: {
    position: 'absolute',
    left: 12,
    top: 24,
    bottom: -theme.spacing(2),
    width: 2,
    borderRadius: 1
  },
  secondaryLine: {
    backgroundColor: theme.palette.secondary.main
  },
  greyLine: {
    backgroundColor: theme.palette.grey[300]
  },
  iconWrapper: {
    marginRight: theme.spacing(2),
    position: 'relative',
    width: 23.5,
    height: 23.5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  circleIcon: {
    width: 7,
    height: 7,
    borderRadius: '50%',
    border: `2px solid ${theme.palette.grey[600]}`
  },
  secondaryColor: {
    color: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main
  },
  infoColor: {
    color: theme.palette.info.main,
    borderColor: theme.palette.info.main
  },
  errorColor: {
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main
  },
  stepContent: {
    flex: 1
  },
  status: {
    fontWeight: 500
  },
  timeText: {
    color: theme.palette.grey[600],
    fontSize: '0.875rem'
  },
  disabledText: {
    color: theme.palette.grey[400],
    fontSize: '0.875rem'
  }
}))

export default useStyles
